import { NavLink } from "react-router-dom";

import OutputCombo from "components/OutputCombo";
import GreenBars from "components/svg/GreenBars";

export default function ElectricityEarnings({ electricityData, showBars }: any) {
  const { soldToGrid = 0, eurosSoldToGrid = 0 } = electricityData ?? {};

  return (
    <div className="output-card">
      {showBars ? (
        <NavLink className="absolute top-6 right-3" to={`${process.env.PUBLIC_URL}/electricity-data`}>
          <GreenBars />
        </NavLink>
      ) : null}
      <div className="flex-shrink-0 pt-7 px-7 mb-3 font-bold">Electricity Earnings</div>
      <div className="flex flex-col justify-between px-7">
        <OutputCombo
          title="Sold To The Grid"
          info="Some Info about"
          bigValue={`${(soldToGrid / 10 ** 6).toFixed(2)} <sup class="text-xs">mW</sup>`}
          smallValue={`= ${eurosSoldToGrid.toLocaleString("en-GB", { style: "currency", currency: "EUR" })}`}
          className="mt-1"
          hasDivide
        />
        <OutputCombo
          title="Standby fees"
          info="Some Info about"
          bottomText="Consumption"
          bottomClassName="text-slate-400"
          smallValue={`= €150`}
          className="mt-3"
          hasDivide
          small
        />
        <OutputCombo bottomText="Production" bottomClassName="text-slate-400" smallValue={`= €${240}`} small />
      </div>
      <div className="flex justify-between items-center p-5 mt-5 bg-slate-100 border-t border-gray-100 font-semibold">
        <h3 className="text-xs">Total Electricity Earnings</h3>
        <div className="text-blue-600">{(eurosSoldToGrid - 390).toLocaleString("en-GB", { style: "currency", currency: "EUR" })}</div>
      </div>
    </div>
  );
}
